import { evaluate } from "mathjs";

export const SoftTagFormula = (softTagFormula, tagValueMap) => {
    try {
        // Extract variable names from the expression
        const variables = softTagFormula.match(/[a-zA-Z_][a-zA-Z0-9_]*/g) || [];
        let values = {};

        // Create a string of variable assignments
        const assignments = variables.map(variable => {
            if (tagValueMap.hasOwnProperty(variable)) {
                values[variable] = tagValueMap[variable];
                return `var ${variable} = ${tagValueMap[variable]};`;
            } else {
                throw new Error(`Value for ${variable} not found in the array`);
            }
        }).join('\n');

        // Evaluate the expression
        const result = evaluate(softTagFormula, values);
        
        // Convert boolean result to 1 or 0 if it's a boolean
        const finalResult = typeof result === 'boolean' ? (result ? 1 : 0) : result;
        
        return { softTagNotGetTag: true, value: finalResult };
    } catch (error) {
        return { softTagNotGetTag: false };
    }
}